import { IconButton, type IconButtonProps, styled } from '@mui/material';

export const CloseButton = styled((props: IconButtonProps) => (
  <IconButton disableRipple disableFocusRipple disableTouchRipple {...props}>
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6.33336L6 18.3334M6 6.33336L18 18.3334"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </IconButton>
))({
  color: '#73808B',
  paddingRight: 0,
});
